import React from "react";
import { Route, Routes } from "react-router-dom";
import { Home } from "../pages/home";
import { AboutUs } from "../pages/about-us";
import { Programs } from "../pages/programs";
import { Ambassador } from "../pages/ambassador";
import { ProgramDetails } from "../pages/program-details";
import { SignIn } from "../pages/sign-in";
import { Dashboard } from "../pages/dashboard/Dashboard";
import UserProfile from "../pages/user-dashbard/user-dashboard-pages/userProfile";
import UserTraining from "../pages/user-dashbard/user-dashboard-pages/userTraining";
import UserProjects from "../pages/user-dashbard/user-dashboard-pages/userProjects";
import UserInternships from "../pages/user-dashbard/user-dashboard-pages/userInternships";
import Usercertificates from "../pages/user-dashbard/user-dashboard-pages/usercertificates";
import MeetsList from "../pages/support-dashboard/meets/meetsList";
import PaymentsList from "../pages/admin-dashboard/payments/paymentsList";
import CreateUser from "../pages/admin-dashboard/users/createUser";
import CreateMeet from "../pages/support-dashboard/meets/createMeet";
import RegisterNow from "../pages/registerNow";
import AllDomainHome from "../components/allDomainHome";
import GetStarted from "../pages/getStarted";
import CreateCourse from "../pages/support-dashboard/ManageCourses/createCourse";
import CoursesList from "../pages/support-dashboard/ManageCourses/manageCourseList";
import UserCalendar from "../pages/user-dashbard/user-dashboard-pages/calendar";
import Cms from "../pages/user-dashbard/user-dashboard-pages/cms";
import RegisterList from "../pages/admin-dashboard/Register/RegisterList";
import StudentsList from "../pages/admin-dashboard/Students Data/StudentsList";
import AmbassadorList from "../pages/admin-dashboard/ambassador/ambassadorList";
import Terms from "../components/Conditions/Terms";
import Refund from "../components/Conditions/Refund";
import Privacy from "../components/Conditions/privacy";
import CreateLmsVideos from "../pages/support-dashboard/LmsVideos/CreateLmsVideos";
import LmsVideoList from "../pages/support-dashboard/LmsVideos/LmsVideoList";
import CertificateList from "../pages/support-dashboard/certificate/certificateList";
import CreateCertificate from "../pages/support-dashboard/certificate/createCertificate";
import EditUser from "../pages/admin-dashboard/users/EditUser";
import CreateAmbassador from "../pages/admin-dashboard/ambassador/createambassador";
import CreateRegisterNow from "../pages/admin-dashboard/Register/createRegisterNow";
import EditMeet from "../pages/support-dashboard/meets/editMeet";
import QueriesList from "../pages/admin-dashboard/queries/queriesList";
import EditCourse from "../pages/support-dashboard/ManageCourses/editCourse";
import ProjectsList from "../pages/support-dashboard/project/projectList";
import CreateProject from "../pages/support-dashboard/project/createProject";
import CgpaList from "../pages/support-dashboard/students/CgpaStudentsList";
import CgpaAccess from "../pages/support-dashboard/students/CgpaAccess";
import CareerGuidances from "../pages/support-dashboard/students/CareerGuidances";
import CareerGuidancesAccess from "../pages/support-dashboard/students/CareerGuidancesAccess";
import SignUpList from "../pages/support-dashboard/HomePage/SignUpList";
import AddSignUpList from "../pages/support-dashboard/HomePage/AddSignUpList";
import VerifyCerificate from "../pages/verify-cerificate";
import LOA from "../pages/user-dashbard/user-dashboard-pages/loa";
import AmbassadorCerificatesList from "../pages/admin-dashboard/adminCerificates/ambassadorCerificatesList";
import AdminLoaList from "../pages/admin-dashboard/adminLoa/AdminLoa";
import AttendanceList from "../pages/support-dashboard/attendance/Attendance";
import UserAttendance from "../pages/user-dashbard/user-dashboard-pages/userAttendance";
import TasksList from "../pages/support-dashboard/tasksList/TasksList";
import CreateTask from "../pages/support-dashboard/tasksList/CreateTask";
import EditPaymentData from "../pages/admin-dashboard/Students Data/EditPaymentData";
import EditTask from "../pages/support-dashboard/tasksList/EditTask";
import EditLmsVideos from "../pages/support-dashboard/LmsVideos/EditLmsVideos";
import RoleAccessList from "../pages/admin-dashboard/roleAccess/RoleAccessList";
import CreateRole from "../pages/admin-dashboard/roleAccess/CreateRole";
import CommisionList from "../pages/manager-dashboard/CommisionList";
import CreateManager from "../pages/manager-dashboard/managerList/CreateManager";
import PrivateCerificates from "../pages/admin-dashboard/cerificatesRelase/privateCerificates";
import CreatePrivateCerificate from "../pages/admin-dashboard/cerificatesRelase/CreatePrivateCerificate";
import RegisterAssessment from "../pages/assessment/RegisterAssessment";
import BannerList from "../pages/exam/banner/BannerList";
import CreateBanner from "../pages/exam/banner/CreateBanner";
import BatchList from "../pages/support-dashboard/Batch/BatchList";
import CreateBatch from "../pages/support-dashboard/Batch/CreateBatch";
import EditBatch from "../pages/support-dashboard/Batch/EditBatch";
import EditAmbassador from "../pages/admin-dashboard/adminCerificates/EditAmbassador";
import PercentageList from "../pages/admin-dashboard/percentage/percentageList";
import CreatePercentage from "../pages/admin-dashboard/percentage/createPercentage";
import EditPercentage from "../pages/admin-dashboard/percentage/editPercentage";
import EditProject from "../pages/support-dashboard/project/EditProject";
import ProjectsData from "../pages/support-dashboard/ProjectData/projectData";
import { ForgotPassword } from "../pages/Forgotpassword";
import ResetPassword from "../pages/user-dashbard/user-dashboard-pages/ResetPassword";
import ChangePassword from "../pages/user-dashbard/user-dashboard-pages/ChangePassword";
import CrmDashboardList from "../pages/Bdi/crm/crmDashboardList";
import ResumeAccessList from "../pages/admin-dashboard/resumeAccess/resumeAccessList";
import CreateResumeAccess from "../pages/admin-dashboard/resumeAccess/createResumeAccess";
import ResumeBuilder from "../pages/user-dashbard/user-dashboard-pages/ResumeBuilder";
import CreateFilterAccess from "../pages/admin-dashboard/filterAccess/CreateFilterAccess";
import FilterAccessList from "../pages/admin-dashboard/filterAccess/FilterAccessList";
import EditFilterAccess from "../pages/admin-dashboard/filterAccess/EditFilterAccess";
import AlertList from "../pages/support-dashboard/alert/alertList";
import CreateAlert from "../pages/support-dashboard/alert/createAlert";
import EditAlert from "../pages/support-dashboard/alert/editAlert";
import ConversionList from "../pages/Bdi/ConversionList";
import UploadList from "../pages/admin-dashboard/uploadStudents/uploadList";
import CreateUpload from "../pages/admin-dashboard/uploadStudents/createUpload";
import BdiStudentList from "../pages/Bdi/bdiStudentList/bdiStudentList";
import QuestionsList from "../pages/exam/manageQuestions/questionsList";
import CreateQuestions from "../pages/exam/manageQuestions/createQuestions";
import EditQuestions from "../pages/exam/manageQuestions/editQuestions";
import RegisterExam from "../pages/exam/writeExam/registerExam";
import DisplayQuestions from "../pages/exam/displayQuestions/DisplayQuestions";
import ResultList from "../pages/exam/result/resultList";
import CollegeList from "../pages/exam/colleges/CollegeList";
import CreateCollege from "../pages/exam/colleges/CreateCollege";
import ManageCollegeList from "../pages/exam/manageQuestions/manageCollgeList";
import ThankYou from "../pages/exam/ThankYou";
import ManageResultList from "../pages/exam/result/manageResultList";
import CareerGuidance from "../components/carrerGuidances/CareerGuidance";

export const RootNavigation = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/home" element={<Home />}></Route>
        <Route path="/verifyCerificate" element={<VerifyCerificate />}></Route>
        <Route path="/about-us" element={<AboutUs />}></Route>
        <Route path="/programs" element={<Programs />}></Route>
        <Route path="/alldomains" element={<AllDomainHome />}></Route>
        <Route path="/ambassador" element={<Ambassador />}></Route>
        <Route path="/program-details" element={<ProgramDetails />}></Route>
        <Route path="/sign-in" element={<SignIn />}></Route>
        <Route path="/forgotPassword" element={<ForgotPassword />}></Route>
        <Route path="/reset/password/:token" element={<ResetPassword />} />

        <Route path="/changePassword" element={<ChangePassword />}></Route>
        <Route path="/Freshers-Career-Guidance" element={<CareerGuidance />}></Route>



        

        <Route path="/dashboard" element={<Dashboard />}></Route>
        <Route path="/dashboard/emailId" element={<Dashboard />}></Route>

        <Route path="/user/profile" element={<UserProfile />}></Route>
        <Route path="/user/training" element={<UserTraining />}></Route>
        <Route path="/user/projects" element={<UserProjects />}></Route>
        <Route path="/user/internships" element={<UserInternships />}></Route>
        <Route path="/user/calendar" element={<UserCalendar />}></Route>
        <Route path="/user/letterhead" element={<LOA />}></Route>
        <Route path="/user/loa" element={<UserAttendance />}></Route>
        <Route path="/support/projectData" element={<ProjectsData />}></Route>
        <Route path="/user/cms" element={<Cms />}></Route>
        <Route path="/user/certificates" element={<Usercertificates />}></Route>
        <Route path="/admin/meetslist" element={<MeetsList />}></Route>
        <Route path="/admin/paymentslist" element={<PaymentsList />}></Route>
        <Route path="/admin/createuser" element={<CreateUser />}></Route>
        <Route path="/support/createmeet" element={<CreateMeet />}></Route>
        <Route path="/support/editCourse" element={<EditCourse />}></Route>
        <Route path="/registernow" element={<RegisterNow />}></Route>
        <Route path="/assessment" element={<RegisterAssessment />}></Route>
        <Route path="/crm/dashboard" element={<CrmDashboardList />}></Route>
        <Route path="/support/alert" element={<AlertList />}></Route>
        <Route path="/bdi/conversionlist" element={<ConversionList />}></Route>

        <Route path="/admin/uploadList" element={<UploadList />}></Route>

        <Route path="/admin/createUpload" element={<CreateUpload />}></Route>

        <Route path="/manager/uploadList" element={<UploadList />}></Route>

        <Route path="/manager/createUpload" element={<CreateUpload />}></Route>

        <Route path="/bdi/studentList" element={<BdiStudentList />}></Route>

        <Route path="/getstarted" element={<GetStarted />}></Route>
        <Route path="/admin/prospectlist" element={<RegisterList />}></Route>
        <Route
          path="/admin/certificatelist"
          element={<AmbassadorCerificatesList />}
        ></Route>
        <Route
          path="/admin/editAmbassador"
          element={<EditAmbassador />}
        ></Route>
        <Route path="/admin/loa" element={<AdminLoaList />}></Route>
        <Route path="/exam/bannerList" element={<BannerList />}></Route>
        <Route path="/exam/createbanner" element={<CreateBanner />}></Route>
        <Route
          path="/admin/percentageList"
          element={<PercentageList />}
        ></Route>
        <Route
          path="/admin/createpercentage"
          element={<CreatePercentage />}
        ></Route>

        <Route
          path="/admin/editPercentage"
          element={<EditPercentage />}
        ></Route>

        {/* <Route path="/bdi/conversionList" element={<ConversionList />}></Route> */}
        {/* <Route path="/managerList" element={<ManagerList />}></Route> */}

        <Route
          path="/manager/conversionList"
          element={<CommisionList />}
        ></Route>
        <Route path="/user/resume" element={<ResumeBuilder />}></Route>

        <Route
          path="/manager/CreateManager"
          element={<CreateManager />}
        ></Route>

        <Route
          path="/admin/privateCerificate"
          element={<PrivateCerificates />}
        ></Route>

        <Route
          path="/admin/createPrivateCerificate"
          element={<CreatePrivateCerificate />}
        ></Route>

        {/* AdminLoaList */}

        <Route
          path="/admin/createregisternow"
          element={<CreateRegisterNow />}
        ></Route>

        <Route path="/admin/roleAccess" element={<RoleAccessList />}></Route>
        <Route path="/admin/createRole" element={<CreateRole />}></Route>
        <Route
          path="/admin/resumeAccess"
          element={<ResumeAccessList />}
        ></Route>
        <Route
          path="/admin/createResumeAccess"
          element={<CreateResumeAccess />}
        ></Route>

        <Route path="/admin/queries" element={<QueriesList />}></Route>

        <Route
          path="/admin/filterAccessList"
          element={<FilterAccessList />}
        ></Route>

        <Route
          path="/admin/createFilterAccess"
          element={<CreateFilterAccess />}
        ></Route>

        <Route
          path="/admin/editFilterAccess"
          element={<EditFilterAccess />}
        ></Route>

        <Route
          path="/admin/ambassadordata"
          element={<AmbassadorList />}
        ></Route>
        <Route
          path="/admin/createambassador"
          element={<CreateAmbassador />}
        ></Route>
        <Route path="/register/students" element={<StudentsList />}></Route>
        <Route path="/support/batchlist" element={<BatchList />}></Route>
        <Route path="/support/createbatch" element={<CreateBatch />}></Route>

        <Route path="/support/meetslist" element={<MeetsList />}></Route>
        <Route path="/support/projectlist" element={<ProjectsList />}></Route>
        <Route
          path="/support/createproject"
          element={<CreateProject />}
        ></Route>
        <Route path="/support/cgpalist" element={<CgpaList />}></Route>
        <Route path="/support/signUpList" element={<SignUpList />}></Route>
        <Route
          path="/support/addSignUpList"
          element={<AddSignUpList />}
        ></Route>

        <Route path="/support/cgpaAccess" element={<CgpaAccess />}></Route>
        <Route
          path="/support/careerGuidances"
          element={<CareerGuidances />}
        ></Route>
        <Route
          path="/support/careerGuidancesAccess"
          element={<CareerGuidancesAccess />}
        ></Route>

        <Route path="/support/createmeet" element={<CreateMeet />}></Route>
        <Route path="/support/editmeet" element={<EditMeet />}></Route>
        <Route path="/support/editProject" element={<EditProject />}></Route>
        <Route path="/support/editbatch" element={<EditBatch />}></Route>
        <Route path="/support/createcourse" element={<CreateCourse />}></Route>
        <Route path="/support/courseslist" element={<CoursesList />}></Route>
        <Route path="/support/loa" element={<AttendanceList />}></Route>
        <Route path="/support/editlms" element={<EditLmsVideos />}></Route>

        <Route path="/terms" element={<Terms />}></Route>
        <Route path="/refund" element={<Refund />}></Route>
        <Route path="/privacy" element={<Privacy />}></Route>
        <Route
          path="/support/createlmscourses"
          element={<CreateLmsVideos />}
        ></Route>
        <Route path="/support/lmsvideolist" element={<LmsVideoList />}></Route>
        <Route
          path="/support/certificatelist"
          element={<CertificateList />}
        ></Route>
        <Route path="/support/tasklist" element={<TasksList />}></Route>
        <Route path="/support/createtask" element={<CreateTask />}></Route>
        <Route path="/support/edittask" element={<EditTask />}></Route>
        <Route path="/support/createalert" element={<CreateAlert />}></Route>

        <Route path="/support/createedit" element={<EditAlert />}></Route>
        <Route path="/exam/questions/:collegeId" element={<QuestionsList />}></Route>
        <Route
          path="/exam/createquestions"
          element={<CreateQuestions />}
        ></Route>
        <Route path="/exam/editquestions" element={<EditQuestions />}></Route>
        <Route path="/exam/manageCollegeList" element={<ManageCollegeList />}></Route>

        <Route path="/exam/manageResultList" element={<ManageResultList />}></Route>

        

        <Route path="/exam/register/:collegeName" element={<RegisterExam />} />
        <Route
          path="/exam/displayquestions/:collegeName"
          element={<DisplayQuestions />}
        />
        <Route
          path="/thank-you"
          element={<ThankYou />}
        />
        <Route path="/exam/collegeList" element={<CollegeList />}></Route>
        <Route path="/exam/createCollege" element={<CreateCollege />}></Route>

        <Route path="/exam/resultList/:resultId" element={<ResultList />}></Route>

        <Route
          path="/admin/editPaymentData"
          element={<EditPaymentData />}
        ></Route>

        <Route
          path="/support/createcertificate"
          element={<CreateCertificate />}
        ></Route>
        <Route path="/admin/editUser" element={<EditUser />}></Route>
      </Routes>
    </>
  );
};
